import { ROUTES } from '@src/routes/constants';

export const MARKETING_ROUTES = [
  ROUTES.REPORTS,
  ROUTES.APPOINTMENTS,
  ROUTES.LEADS,
  ROUTES.TASKS,
] as const;

export const isMarketingUser = (userType?: string) => userType === 'MARKETING';

export const getDefaultRouteForUser = (userType?: string): string => {
  if (userType === 'MASTER_ADMIN') return ROUTES.ORGANIZATIONS;
  if (userType === 'MARKETING') return ROUTES.APPOINTMENTS;
  return ROUTES.OFFERINGS;
};

export const canAccessRoute = (
  userType: string | undefined,
  pathname: string
): boolean => {
  if (!userType) return false;

  if (userType === 'MASTER_ADMIN') {
    return (
      pathname.startsWith(ROUTES.ORGANIZATIONS) ||
      pathname.startsWith(ROUTES.USERS) ||
      pathname.startsWith(ROUTES.BRANCHES)
    );
  }

  if (userType === 'MARKETING') {
    return MARKETING_ROUTES.some(
      route => pathname === route || pathname.startsWith(`${route}/`)
    );
  }

  // All other roles: block master-admin-only routes
  if (
    pathname.startsWith(ROUTES.ORGANIZATIONS) ||
    pathname.startsWith(ROUTES.BRANCHES)
  ) {
    return false;
  }

  // Users page is admin+ only
  if (pathname.startsWith(ROUTES.USERS)) {
    return ['ADMIN', 'DOCTOR'].includes(userType);
  }

  return true;
};

export const canAccessSidebarItem = (
  userType: string | undefined,
  itemKey: string,
  canAccessRestrictedPages: boolean
): boolean => {
  if (!userType) return false;

  if (userType === 'MARKETING') {
    return MARKETING_ROUTES.includes(itemKey as (typeof MARKETING_ROUTES)[number]);
  }

  if (itemKey === ROUTES.REPORTS || itemKey === ROUTES.PAYMENTS) {
    return canAccessRestrictedPages;
  }

  if (itemKey === ROUTES.ORGANIZATIONS) {
    return userType === 'MASTER_ADMIN';
  }

  if (itemKey === ROUTES.USERS) {
    return ['MASTER_ADMIN', 'ADMIN', 'DOCTOR'].includes(userType);
  }

  return userType !== 'MASTER_ADMIN';
};
